module.exports = __webpack_public_path__ + "img/cg_icon.f6391551.png";